import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ClientRouter } from './pages/client';
import { AdminRouter } from './pages/admin';
import './styles/design-system.css';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Client App (public) - /inspecao/* */}
        <Route path="/inspecao/*" element={<ClientRouter />} />
        
        {/* Admin App (private) - /admin/* */}
        <Route path="/admin/*" element={<AdminRouter />} />
        
        {/* Default redirect to client landing */}
        <Route path="/" element={<Navigate to="/inspecao" replace />} />
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to="/inspecao" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;